import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://rwxeylzjbdiiqsagqfej.supabase.co"

const supabaseKey = "sb_publishable_SnAnQxtkqs3VZXzXwRLjfQ_oBSRVKCL"

export const supabase = createClient(supabaseUrl, supabaseKey, {
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  fetch: (url, options) => {
    return fetch(url, {
      ...options,
      headers: {
        ...options?.headers,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
  }
})